import { useConfig } from '../../Common/hooks/useConfig';
import { isDev } from '../../Common/hooks/useIsDev';

export const usePowerboard = (brand: string) => {
  const { configForBrand } = useConfig();

  const createToken = async (
    cardNumber: string,
    cardHolder: string,
    ccv: string,
    expMonth: string,
    expYear: string,
  ) => {
    const { paymentGatewayID, paymentGatewayAPIPublicKey } = configForBrand(brand);

    const hostname = isDev()
      ? 'api.preproduction.powerboard.commbank.com.au'
      : 'api.powerboard.commbank.com.au';

    const response = await fetch(`https://${hostname}/v1/payment_sources/tokens`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-user-public-key': paymentGatewayAPIPublicKey,
      },
      body: JSON.stringify({
        gateway_id: paymentGatewayID,
        type: 'card',
        card_name: cardHolder,
        card_number: cardNumber.replace(/\s/g, '').trim(),
        expire_month: expMonth.trim(),
        expire_year: expYear.trim(),
        card_ccv: ccv,
      }),
    });

    const json = await response.json();

    const tokenID = json?.resource?.data;

    return tokenID;
  };

  return { createToken };
};
